export default "__VITE_ASSET__DTkARquA__"